module.exports = __webpack_public_path__ + "static/fonts/Sansation-Light-webfont.bd0c681.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Sansation/Sansation-Light-webfont.woff
// module id = Grfv
// module chunks = 0